<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-notification-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupNotificationContainerView: () => import('@/components/hris/setup/notification/ContainerView'),
    },
  }
</script>
